import { render, staticRenderFns } from "./DialogDelete.vue?vue&type=template&id=574c4f4e&scoped=true"
import script from "./DialogDelete.vue?vue&type=script&lang=js"
export * from "./DialogDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c4f4e",
  null
  
)

export default component.exports